// Our own internal payment method values — not an exhaustive list of what we receive from Datatrans
export const PaymentMethod = {
  Direct: 'DIRECT',
  Skip: 'SKIP',
  Unk: 'UNK',
} as const;

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];
